import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Popconfirm,
  message,
  Row,
  Col,
} from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { API_URL } from "../../config";
import AntDesignTable from "../common/antTable/AntDesignTable";
import TabletForm from "./TabletForm";
import CommonModal from "../common/commonModal/CommonModal";
import { useTranslation } from "react-i18next";
import "../index.css";

const TabletsContainer = () => {
  const [tablets, setTablets] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentTablet, setCurrentTablet] = useState(null);
  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    fetchTablets();
  }, []);

  const fetchTablets = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/tablet/?skip=0&limit=100`,
      );
      setTablets(response.data);
    } catch (error) {
      console.error("There was an error fetching the tablet data!", error);
    }
  };

  const handleCreate = () => {
    setCurrentTablet(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEdit = (tablet) => {
    setCurrentTablet(tablet);
    form.setFieldsValue(tablet);
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    try {
      await form.validateFields();
      const formData = form.getFieldsValue();

      if (currentTablet) {
        await axios.patch(`${API_URL}/tablet/${currentTablet.id}`, formData);
        message.success(t("message.tabletUpdatedSuccessfully"));
      } else {
        await axios.post(`${API_URL}/tablet/`, formData);
        message.success(t("message.tabletCreatedSuccessfully"));
      }

      setIsModalVisible(false);
      fetchTablets();
    } catch (error) {
      console.error("There was an error saving the tablet data!", error);
      message.error(t("message.failedTabletSave"));
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleDelete = async (tabletId) => {
    try {
      await axios.delete(`${API_URL}/tablet/${tabletId}`);
       message.success(t("message.tabletDeletedSuccessfully"));
      fetchTablets();
    } catch (error) {
      console.error("There was an error deleting the tablet!", error);
      message.error(t("message.failedTabletDelete"));
    }
  };

  const columns = [
    {
      title: t("tableHeader.id"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("tableHeader.tabletId"),
      dataIndex: "tablet_id",
      key: "tablet_id",
    },
    {
      title: t("tableHeader.creationOwner"),
      dataIndex: "creation_owner",
      key: "creation_owner",
    },
    {
      title: t("tableHeader.action"),
      key: "actions",
      render: (_, tablet) => (
        <span>
          <Row gutter={[8, 8]}>
            <Col xs={12} sm={8} md={6}>
              <Button
                className="edit-button"
                icon={<EditOutlined />}
                onClick={() => handleEdit(tablet)}
                style={{ marginRight: 8 }}
              ></Button>
            </Col>
            <Col xs={12} sm={8} md={6}>
              <Popconfirm
                title={t("message.tabletDeleteConfirmation")}
                okText={t("common.yes")}
                cancelText={t("common.no")}
                onConfirm={() => handleDelete(tablet.id)}
              >
                <Button
                  className="delete-button"
                  icon={<DeleteOutlined />}
                  danger
                ></Button>
              </Popconfirm>
            </Col>
          </Row>
        </span>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
       {t("tableHeader.createNewTablet")}
      </Button>
      <AntDesignTable columns={columns} tableData={tablets} />
      <CommonModal
        title={currentTablet ? t("tableHeader.editTablet") : t("tableHeader.createTablet")}
        visible={isModalVisible}
        onCancel={handleCancel}
        onConfirm={handleOk}
        confirmButtonText={currentTablet ? t("common.update") : t("common.submit")}
        width={300}
      >
        <TabletForm form={form} initialFormData={currentTablet} />
      </CommonModal>
    </React.Fragment>
  );
};

export default TabletsContainer;
